// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"37d40071","453":"b21a91d2","516":"373daf38","560":"7a143807","872":"67309a48"}[chunkId] + ".chunk.js";
};